import React from 'react';
import { motion } from 'framer-motion';
import Hero from '../components/Hero';
import SafeIcon from '../common/SafeIcon';
import SitePartner from '../components/SitePartner';

const WeatherGurusPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 pb-20">
      <Hero 
        title="Weather Gurus" 
        subtitle="local weather enthusiasts and community updates"
        imageUrl="https://res.cloudinary.com/dufyzcc72/image/upload/v1773626875/Untitled-11_a06e6l.jpg"
      />
      <div className="max-w-3xl mx-auto px-4 mt-6">
        <SitePartner />
        <div className="flex flex-col gap-10 mt-6">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="bg-white rounded-[2.5rem] shadow-2xl border border-slate-200 overflow-hidden" >
            <div className="p-8 pb-4 text-center">
              <h3 className="text-2xl font-black text-slate-900 uppercase tracking-tighter"> PEI STORM NEWS UPDATES </h3>
              <p className="text-slate-500 font-bold text-sm uppercase mt-1 flex items-center justify-center gap-2"> <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span> Live Page Feed </p>
            </div>
            <div className="w-full flex justify-center bg-slate-100 p-4">
              <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FPEIStormNewsUpdates%2F&tabs=timeline&width=500&height=600&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="500" height="600" style={{ border: 'none', overflow: 'hidden', borderRadius: '1.5rem' }} scrolling="no" frameBorder="0" allowFullScreen={true} allow="autoplay;clipboard-write;encrypted-media;picture-in-picture;web-share" title="PEI Storm News Updates Feed" className="max-w-full" ></iframe>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default WeatherGurusPage;